exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "span[data-v-fb28d4ca]{display:inline-block;margin:0;padding:0;font-size:15px;line-height:1}", "", {"version":3,"sources":["/Users/Min/Work/Code/ThirdApps/kanjia/front/src/base/number/index.vue"],"names":[],"mappings":"AACA,sBACE,qBAAsB,AACtB,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,aAAe,CAChB","file":"index.vue","sourcesContent":["\nspan[data-v-fb28d4ca] {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  font-size: 15px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fb28d4ca","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/base/number/index.vue
// module id = 247
// module chunks = 0